import { 
  Component, 
  OnInit,
  OnDestroy,
  OnChanges,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  Inject,
  forwardRef
} from '@angular/core';

import { 
  FormGroup,
  Validators 
} from '@angular/forms';

import { isEqual, isNil } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil, mergeMap, shareReplay } from 'rxjs/operators';

import { DatexFormControl, validateControlOnChange, validateFormOnControlChange } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles,
  ValueControlModel
} from './models/control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { FieldsetModel } from './models/fieldset';
import { ToolModel } from './models/tool';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_bulk_licenseplate_directed_move_form_ComponentContextService } from './FootprintManager.bulk_licenseplate_directed_move_form.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { Locations_locations_dd_singleComponent } from './Locations.locations_dd_single.component'
import { Inventory_reasoncodes_dd_singleComponent } from './Inventory.reasoncodes_dd_single.component'

@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => Locations_locations_dd_singleComponent),
    forwardRef(() => Inventory_reasoncodes_dd_singleComponent),
  ],
  selector: 'FootprintManager-bulk_licenseplate_directed_move_form',
  templateUrl: './FootprintManager.bulk_licenseplate_directed_move_form.component.html'
})
export class FootprintManager_bulk_licenseplate_directed_move_formComponent extends BaseComponent implements OnInit, OnDestroy, OnChanges {

  inParams: { licenseplates: { id?: number, warehouseId?: number, typeId?: number, locationId?: number }[] } = { licenseplates: [] };
  //#region Inputs
  @Input('licenseplates') set $inParams_licenseplates(v: { id?: number, warehouseId?: number, typeId?: number, locationId?: number }[]) {
    this.inParams.licenseplates = v;
  }
  get $inParams_licenseplates(): { id?: number, warehouseId?: number, typeId?: number, locationId?: number }[] {
    return this.inParams.licenseplates;
  }
  //#endregion Inputs

  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  outParams: { confirm?: boolean } = { confirm: null };
  //#endregion

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  vars: { licenseplateIds?: number[] } = { };
  //#endregion
  //#region Events
  @Output()
  outParamsChange = new EventEmitter<{ confirm?: boolean }>();
  
  events = {
    outParamsChange: { emit: () => { this.outParamsChange.emit(this.outParams); } }
  }
  //#endregion

  formGroup: FormGroup = new FormGroup({
    target_location: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    reasoncode: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'blur' }),
  });

  get valid(): boolean {
    return this.formGroup.valid;
  }
  
  toolbar = {
      release: new ToolModel(new ButtonModel('release', new ButtonStyles(['primary'], null), false, false, false, 'Release', '', null)
    , false)
  };

  fields = {
    target_location: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['target_location'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Target location', false, false),
    reasoncode: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['reasoncode'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Reason code', true, false),
  };

  fieldsets = {
    newGroup1: new FieldsetModel(
      '',
      true,
      false,
      true,
      false,
        null
      ,
      () => {
        const $form = this;
        const $utils = this.$utils;
        return '';
      }
    ),
};

  //#region fields inParams
  get $fields_target_location_selector_inParams_warehouseId(): number {
    const $form = this;
    const $utils = this.$utils;
    const expr = $form.inParams.licenseplates[0]?.warehouseId;
    
    return expr;
  }

  get $fields_target_location_selector_inParams_typeId(): number {
    const $form = this;
    const $utils = this.$utils;
    const expr = 3;
    
    return expr;
  }

  get $fields_target_location_selector_inParams_isLoose(): boolean {
    const $form = this;
    const $utils = this.$utils;
    const expr = false;
    
    return expr;
  }

  get $fields_reasoncode_selector_inParams_parentId(): number {
    const $form = this;
    const $utils = this.$utils;
    const expr = 5;
    
    return expr;
  }

  get $fields_reasoncode_selector_inParams_parentEntity(): string {
    const $form = this;
    const $utils = this.$utils;
    const expr = 'OperationType';
    
    return expr;
  }

  //#endregion fields inParams

  $formGroupFieldValidationObservables = {
    target_location: this.fields.target_location.control.valueChanges
    ,
    reasoncode: this.fields.reasoncode.control.valueChanges
    ,
  }
  

  constructor(
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_bulk_licenseplate_directed_move_form_ComponentContextService,
) { 
    super();
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if (!this.$hasMissingRequiredInParams) {
      this.$init();
    } else {
      this.$initEmpty();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      } else {
        this.$initEmpty();
      }
    }
  }

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }
  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.licenseplates)) {
        this.$missingRequiredInParams.push('licenseplates');
      }
  }

  initialized = false;

  async $init() {
    this.title = 'Move License Plates';
  
    const $form = this;
    const $utils = this.$utils;


    await this.on_init();

    this.initialized = true;
  }

  private $subscribeFormControlValueChanges() {
    this.$formGroupFieldValidationObservables
      .target_location
      .pipe(takeUntil(this.$unsubscribe$))
      .subscribe();
    this.$formGroupFieldValidationObservables
      .reasoncode
      .pipe(takeUntil(this.$unsubscribe$))
      .subscribe();
  }

  close() {
    this.$finish.emit();
  }

  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }
 
  //#region private flows
  on_release_clicked(event = null) {
    return this.on_release_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_release_clickedInternal(
    $form: FootprintManager_bulk_licenseplate_directed_move_formComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_bulk_licenseplate_directed_move_form_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $form.outParams.confirm = true;
  $form.toolbar.release.control.readOnly = true;
  $form.fields.reasoncode.control.readOnly = true;
  $form.fields.target_location.control.readOnly = true;
  
  try {
      if (!$utils.isAllDefined(
          $form.fields.reasoncode.control.value
      )) {
          throw new Error('Please enter a value for all required fields.');
      }
  
      let promises: any[] = [];
      for (let licenseplateId of $form.vars.licenseplateIds) {
          if ($form.inParams.licenseplates.find(lp => lp.id === licenseplateId).locationId !== $form.fields.target_location.control.value) {
              // Release LicensePlateMove
              promises.push($flows.Inventory.create_released_licenseplate_move_task_flow({
                  licenseplateId: licenseplateId,
                  targetLocationId: $form.fields.target_location.control.value,
                  reasoncodeId: $form.fields.reasoncode.control.value
              }));
          }
      }
  
      let reasons: string[] = [];
  
      await Promise.all(promises)
          .then((results) => {
              for (let result of results) {
                  reasons = reasons.concat(result.reasons);
              }
          })
          .catch(error => {
              $shell.FootprintManager.openErrorDialog('Error moving license plates', error.message);
          });
  
      if ($utils.isDefined(reasons)) {
          throw new Error(reasons[0]);
      }
  
      $form.close();
  }
  catch (error) {
      $shell.FootprintManager.openErrorDialog('Error releasing batch moves', $utils.isDefined(error?.error?.error) ? error.error.error.message : error.message);
  }
  
  $form.toolbar.release.control.readOnly = false;
  $form.fields.reasoncode.control.readOnly = false;
  $form.fields.target_location.control.readOnly = false;
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $form: FootprintManager_bulk_licenseplate_directed_move_formComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_bulk_licenseplate_directed_move_form_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $form.outParams.confirm = false;
  
  // Validate LicensePlates
  if ($form.inParams.licenseplates.find(lp => lp.typeId !== 1)) {
      throw new Error(`Invalid Request: Only license plates of type 'Inventory' can be moved in bulk.`);
  }
  
  if ([...new Set($form.inParams.licenseplates.map(lp => lp.warehouseId))].length > 1) {
      throw new Error(`Invalid request: Selected license plates exist in separate warehouses. A bulk move can only be conducted for one warehouse at a time.`);
  }
  
  // Group LicensePlateIds
  $form.vars.licenseplateIds = [...new Set($form.inParams.licenseplates.map(lp => lp.id))];
  
  // Set Form Title
  $form.title = `Release move tasks for ${$form.vars.licenseplateIds.length} license plates?`;
  }
  //#endregion private flows
}
